import React, { useRef, useState, useEffect } from "react";
import mapboxgl from "!mapbox-gl"; // eslint-disable-line import/no-webpack-loader-syntax
import bbox from "@turf/bbox";
import _ from "lodash";

mapboxgl.accessToken =
  "pk.eyJ1IjoidG5iM2siLCJhIjoiY2ptNm14bHQ2MWNubzN3bjJmZjJxOWlwOCJ9.JM2XrfZHVM26uw2bQAjZsA";

let currentMarkers = [];

export default function Map(props) {
  const mapContainer = useRef(null);
  const map = useRef(null);
  const [layers, setLayers] = useState([]);

  //Initialize the map
  useEffect(() => {
    if (map.current) return; //initialize map only once
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/tnb3k/cl3bx0fob003415mpsinmib3i",
      interactive: false,
      center: [props.lng, props.lat],
      pitch: props.pitch,
      zoom: props.zoom,
    });

    //

    //On map load, add Sources and Layers
    https: map.current.on("load", () => {
      // eslint-disable-next-line array-callback-return
      props.data.map((place) => {
        const nid = place.nid;
        const geo = place.geo;
        setLayers((layers) => [...layers, { nid: nid, geo: geo }]);
        if (geo) {
          map.current.addSource(nid, { type: "geojson", data: geo });
          map.current.addLayer({
            id: nid,
            visibility: "none",
            type: "fill",
            source: nid,
            layout: {
              visibility: "visible",
            },
            paint: {
              "fill-color": "#988046",
              "fill-opacity": 0.8,
              "fill-opacity-transition": { duration: 500 },
              "fill-color-transition": { duration: 500 },
            },
          });
        }
      });
    });
  });

  //handle FlyTo Animations
  useEffect(() => {
    map.current.flyTo({
      zoom: props.zoom,
      pitch: props.pitch,
      center: [props.lng, props.lat],
    });
  }, [props.zoom, props.pitch, props.lng, props.lat]);

  //handle FitToBounds by
  useEffect(() => {
    if (props.bounds) {
      //for lineString bounds
      const [minLng, minLat, maxLng, maxLat] = bbox(props.bounds);
      map.current.fitBounds(
        [
          [minLng, minLat],
          [maxLng, maxLat],
        ],
        { padding: 30, duration: 1000 }
      );
    }
  }, [props.bounds]);

  //handle icons
  useEffect(() => {
    if (!_.isEmpty(props.icons)) {
      currentMarkers?.forEach((mark) => {
        mark.remove();
      });
      props.icons.forEach((markers) => {
        markers.forEach((mark) => {
          mark.addTo(map.current);
          currentMarkers.push(mark);
        });
      });
    } else {
      currentMarkers?.forEach((mark) => {
        mark.remove();
      });
    }
  }, [props.icons]);

  //handle fading-in a layer
  useEffect(() => {
    if (props.layerID !== "0" && !_.isEmpty(props.icons)) {
      map.current.setPaintProperty(props.layerID, "fill-color", "#988046");
      layers.forEach((layer) => {
        if (layer.nid !== props.layerID) {
          map.current.setPaintProperty(layer.nid, "fill-color", "#EFE2C3");
        }
      });
    } else {
      layers.forEach((layer) => {
        if (layer.nid !== props.layerID) {
          map.current.setPaintProperty(layer.nid, "fill-color", "#988046");
        }
      });
    }
  }, [props.layerID]);

  return (
    <div>
      <div ref={mapContainer} className="map-container" />
    </div>
  );
}
